import React from "react";

import viewIcon from "images/icons/invite/view.svg";
import editIcon from "images/icons/invite/edit.svg";
import deleteIcon from "images/icons/invite/delete.svg";
import cloneIcon from "images/icons/invite/clone.svg";

import { useCoachPoolContext } from "../../../../contexts/CoachPoolContext";
import Tooltip from "../../../ui/Tooltip";

export default function Actions({ row }) {
  const { dispatch, actions } = useCoachPoolContext();

  const editCoachPool = (e, row) => {
    actions.editCoachPool(row.id);
  };

  const deleteCoachPool = (e, row) => {
    swal(
      {
        title: "",
        text: "Do you want to delete this coach pool?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== "A") {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.deleteCoachPool(dispatch, row.id);
        }
      }
    );
  };

  const duplicateCoachPool = (e, row) => {
    swal(
      {
        title: "",
        text: "Do you want to duplicate this coach pool?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Duplicate",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== "A") {
            el = el.parentNode;
          }
          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.duplicateCoachPool(dispatch, row.id, (newCoachPool) => {
            actions.viewCoachPool(newCoachPool.id);
          });
        }
      }
    );
  };

  const viewCoachPool = (e, row) => {
    actions.viewCoachPool(row.id);
  };

  return (
    <div>
      <a
        data-tip="View Coach Pool"
        onClick={(e) => viewCoachPool(e, row)}
        className="mr5"
      >
        <img src={viewIcon} />
      </a>

      <a
        data-tip="Edit Coach Pool"
        onClick={(e) => editCoachPool(e, row)}
        className="mr5"
      >
        <img src={editIcon} />
      </a>

      <a
        data-tip="Duplicate Coach Pool"
        onClick={(e) => duplicateCoachPool(e, row)}
        className="mr5"
      >
        <img src={cloneIcon} />
      </a>

      <a data-tip="Delete Coach Pool" onClick={(e) => deleteCoachPool(e, row)}>
        <img src={deleteIcon} />
      </a>
      <Tooltip />
    </div>
  );
}
